/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { LEGACY_TAB_SEGMENTS, type BankAccountTab } from '@/modules/bank-account/route';

// Caminhos antigos das abas (`router.tsx:411-482`): o link salvo cai no detalhe com `?tab=`.
export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/$tab')({
  beforeLoad: ({ params }) => {
    const tab = (LEGACY_TAB_SEGMENTS as readonly string[]).includes(params.tab) ? (params.tab as BankAccountTab) : undefined;
    throw redirect({ to: '/contas-digitais/contas/$bankAccountId', params: { bankAccountId: params.bankAccountId }, search: tab ? { tab } : {}, replace: true });
  },
});
